import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
// import {
//   convertLocalDate,
//   convertLocalTime,
// } from "../../../../Utils/configController";
import LogsDataTable from "./LogsDataTable";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const ScheduleList = ({ userId, selectedPremise }: ChipsControlProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const columns = [
    // {
    //   name: "Slave",
    //   selector: (row: any) => row?.slave || "-",
    //   sortable: true,
    //   grow: 1,
    //   wrap: true,
    // },
    {
      name: "Slave & scene",
      selector: (row: any) => {
        if (row?.slave) {
          return row.slave;
        }

        if (row?.deviceType === "scene") {
          return row?.deviceName || "-";
        }

        return "-";
      },
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Type",
      selector: (row: any) => row?.deviceType || "-",

      sortable: true,
      grow: 1,
      wrap: true,
    },

    {
      name: "Button",
      selector: (row: any) => row?.button || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Button Value",
      selector: (row: any) => row?.executeValue || "-",
      sortable: true,
      grow: 1,
      wrap: true,
    },

    {
      name: "Day Numbers",
      cell: (row: any) => {
        const dayMap: any = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        const days = row?.dayNumbers?.map((i: number) => dayMap[i]) || [];

        return days.length ? (
          <div className="d-flex flex-wrap gap-1">
            {days.map((d: string, idx: number) => (
              <span
                key={idx}
                className="badge bg-primary text-white"
                style={{ fontSize: "11px" }}
              >
                {d}
              </span>
            ))}
          </div>
        ) : (
          "-"
        );
      },
      sortable: false,
      grow: 2,
      wrap: true,
    },
    {
      name: "Is Active",
      selector: (row: any) =>
        row?.isActive ? (
          <div className="bg-success text-white px-2 py-1 rounded text-center fw-bold">
            Active
          </div>
        ) : (
          <div className="bg-danger text-white px-2 py-1 rounded text-center fw-bold">
            Inactive
          </div>
        ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Time",
      cell: (row: any) => <span>{row?.istTime ? row.istTime : "-"}</span>,
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Is Repeat",
      selector: (row: any) => (row?.isRepeat ? "True" : "False"),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Next Run",
      cell: (row: any) =>
        row?.istNextRun ? <span>{row.istNextRun}</span> : "-",
      sortable: true,
      grow: 2,
      wrap: true,
    },
  ];

  return (
    <div>
      <LogsDataTable
        apiURL={`${url.BASE_URL}${url.GET_SCHEDULE_LIST}`}
        title="Schedule List"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
        selectedPremise={selectedPremise}
      />
    </div>
  );
};

export default ScheduleList;
